export const MetricsMap = {
    CUSTOM_IMPRESSIONS: {
        value: 'custom_impressions',
        label: 'Impressions',
        shortLabel: 'Impr',
    },
    CUSTOM_CLICKS: {
        value: 'custom_clicks',
        label: 'Clicks',
    },
    CUSTOM_INSTALLS: {
        value: 'custom_installs',
        label: 'Installs',
    },
    COST: {
        value: 'adn_cost',
        label: 'Cost',
    },
    IPM: {
        value: 'ipm',
        label: 'IPM',
    },
    ECPM: {
        value: 'ecpm',
        label: 'eCPM',
    },
    ECPI: {
        value: 'ecpi',
        label: 'eCPI',
    },
    CTR: {
        value: 'ctr',
        label: 'CTR',
    },
    CVR: {
        value: 'cvr',
        label: 'CVR',
    },
    VIDEO_VIEWS: {
        value: 'video_views',
        label: 'Video Views',
        shortLabel: 'VV',
        isLazy: true,
    },
    VIDEO_VIEWS_25PCT: {
        value: 'video_views_25pct',
        label: 'Video Views 25%',
        shortLabel: 'VV25',
        isLazy: true,
    },
    VIDEO_VIEWS_50PCT: {
        value: 'video_views_50pct',
        label: 'Video Views 50%',
        shortLabel: 'VV50',
        isLazy: true,
    },
    VIDEO_VIEWS_75PCT: {
        value: 'video_views_75pct',
        label: 'Video Views 75%',
        shortLabel: 'VV75',
        isLazy: true,
    },
    COMPLETED_VIDEO_VIEWS: {
        value: 'completed_video_views',
        label: 'Completed Video Views',
        shortLabel: 'CVV',
        isLazy: true,
    },
    COMPLETED_VIDEO_VIEW_RATE: {
        value: 'completed_video_view_rate',
        label: 'Completed Video View Rate',
        shortLabel: 'CVV-R',
        isLazy: true,
    },
    VIDEO_VIEWS_15SEC_COMPLETED: {
        value: 'video_views_15sec_completed',
        label: 'Meta - 15sec video view completed',
        shortLabel: 'VV15s',
        isLazy: true,
    },
    VIDEO_VIEWS_30SEC_COMPLETED: {
        value: 'video_views_30sec_completed',
        label: 'Meta - 30sec video view completed',
        shortLabel: 'VV30s',
        isLazy: true,
    },
    RE_ENGAGEMENTS: {
        value: 'tracker_reengagements',
        label: 'Re-engagements',
        isLazy: true,
    },
    CONVERSIONS: {
        value: 'tracker_conversions',
        label: 'Conversions',
        isLazy: true,
    },
    COST_PER_CONVERSION: {
        value: 'cost_per_conversion',
        label: 'Cost per Conversion',
        isLazy: true,
    },
    COST_PER_RE_ENGAGEMENT: {
        value: 'cost_per_reengagement',
        label: 'Cost per Re-engagement',
        isLazy: true,
    },
    RE_ENGAGEMENTS_CVR: {
        value: 'reengagement_cvr',
        label: 'Re-engagement CVR',
        isLazy: true,
    },
    APP_INSTALLS: {
        value: 'app_tracker_installs',
        label: 'App Installs',
        isLazy: true,
    },
    APP_RE_ENGAGEMENTS: {
        value: 'app_tracker_reengagements',
        label: 'App Re-engagements',
        isLazy: true,
    },
    TOTAL_APP_CONVERSIONS: {
        value: 'total_app_conversions',
        label: 'Total App Conversions',
        isLazy: true,
    },
};

export const CREATIVES_CORE_METRICS_OPTIONS = Object.values(MetricsMap).map(({ value }) => value);

export const getMetricsToFetch = (availableMetrics, selectedMetrics) => {
    const selectedValues = new Set(selectedMetrics.map(({ value }) => value));
    return availableMetrics.filter(({ value, isLazy }) => !isLazy || selectedValues.has(value));
};

export const getEagerMetrics = availableMetrics => getMetricsToFetch(availableMetrics, []);

export const getAvailableMetricsOptions = (allUserMetrics, allRequestedMetrics) => {
    const allMetricNames = new Set(allUserMetrics.map(({ name }) => name));

    return allRequestedMetrics.filter(name => allMetricNames.has(name));
};

const getSortedMetrics = metrics => {
    const sortCallback = (a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase());

    return Array.prototype.toSorted ? metrics.toSorted(sortCallback) : [...metrics].sort(sortCallback);
};

export const getCohortFieldAndPeriod = field => {
    const fieldParts = field.split('_');
    if (fieldParts.length === 1) return [field, ''];
    const cohortPeriod = fieldParts[fieldParts.length - 1];
    const cohortMetric = fieldParts.slice(0, fieldParts.length - 1).join('_');

    return [cohortMetric, cohortPeriod];
};

export const ALL_METRICS_OPTIONS = Object.values(MetricsMap);
export const SORTED_METRICS_OPTIONS = getSortedMetrics(ALL_METRICS_OPTIONS);

const LAZY_METRIC_VALUES = new Set(ALL_METRICS_OPTIONS.filter(({ isLazy }) => isLazy).map(({ value }) => value));

export const containsLazyMetric = metricValues => (metricValues || []).some(value => LAZY_METRIC_VALUES.has(value));

export const createCohortOptions = (options, periods) =>
    options.reduce((acc, field) => {
        periods.forEach(period => {
            acc.push({
                value: `${field.name}_${period.name}`,
                label: `${field.display_name} ${period.name}`,
                display_format: field.display_format,
            });
        });

        return acc;
    }, []);

export const CohortGroupsToLabel = {
    Metrics: 'STATIC.COHORT_METRICS',
    ConversionEvents: 'STATIC.CONVERSION_EVENTS',
    CohortEvents: 'STATIC.COHORT_EVENTS',
    SpecialMetrics: 'STATIC.METRICS',
};
